export default "__VITE_ASSET__BiNMpTNi__"